import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { HisSearchResultComponent, HisAuthService } from 'hisng';

import { PublicationService } from 'app/fs/res/publication/service/publication.service';
import { PublicationModuleOptions } from '../../../publication-module.options';

@Component( {
    selector: 'res-publication-duplicates-search-result',
    templateUrl: './publication-duplicates-search-result.component.html'
} )
export class PublicationDuplicatesSearchResultComponent implements OnInit {

    public readonly moduleOptions = PublicationModuleOptions;

    @ViewChild( HisSearchResultComponent, { static: true } ) searchResultComponent: HisSearchResultComponent;

    public prevPage: string;

    /** Die id der Publikation, die im Header der Duplikatsseite angezeigt werden soll */
    mainPublicationId: number;

    constructor(
        public auth: HisAuthService,
        private route: ActivatedRoute,
        private publicationService: PublicationService
    ) { }

    ngOnInit() {
        this.publicationService.userProfileService.getValueforKey('duplicatesResultview').subscribe( (value: string) => {
            this.publicationService.switchListTable('duplicatesResultview', value==='Liste');
        });

        this.route.params.subscribe( (routeParams: Params) => {
            console.log('routeParams = ', JSON.stringify(routeParams));
            this.mainPublicationId = parseInt(routeParams.mainPublicationId, 10);
        } );

        this.route.queryParams.subscribe( (queryParams: Params) => {
            console.log('queryParams = ', JSON.stringify(queryParams));
            if (queryParams.prevPage) {
                this.prevPage = queryParams.prevPage;
            }
        } );
    }

    // Diese Methode wird nur in der Listenansicht der Importkandidaten aufgerufen...
    onPage( event: { first: number; rows: number } ) {
        this.searchResultComponent.loadPage( event.first );
        this.searchResultComponent.onPage( event );
    }
}
